// ============= Imports =============

import type { ReactElement } from 'react';
import type { RejectionDetailItem } from './types';

// ============= Types =============

interface RejectionMessageProps {
  baseMessage: string;
  detailItems: RejectionDetailItem[];
}

// ============= Component =============

export const RejectionMessage = ({
  baseMessage,
  detailItems,
}: RejectionMessageProps): ReactElement => (
  <div>
    <p style={{ margin: 0 }}>
      <strong>Form Rejected:</strong> {baseMessage}
    </p>
    {detailItems.length > 0 && (
      <ul
        style={{
          margin: '0.5rem 0 0',
          paddingLeft: '1.25rem',
        }}
      >
        {detailItems.map(({ label, value }) => (
          <li key={label}>
            <strong>{label}:</strong> {value}
          </li>
        ))}
      </ul>
    )}
  </div>
);
